import { Navigate, Route, Routes } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
import { useGetUserProfile } from 'src/hooks/profile.hooks';
import StudentReport from 'src/pages/university/StudentReport';
import UniversityDashboard from 'src/pages/university/UniversityDashboard';

const UniversityRoutes = () => {
	const { user } = useUserContext();
	const userProfile = useGetUserProfile(user?.handler ?? '');

	if (userProfile.isLoading) {
		return null;
	}

	return (
		<Routes>
			<Route path="/" element={<UniversityDashboard />} />
			<Route path="/student-reports" element={<StudentReport />} />
			<Route path="*" element={<Navigate to="/" />} />
		</Routes>
	);
};

export default UniversityRoutes;
